import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';
import { Utils } from 'src/modules/utils/shared/utils';
import { FileUploadService } from '../../services/file-upload.service';
import { Arrays } from 'src/modules/utils/shared/arrays';
import { Strings } from 'src/modules/utils/shared/strings';

@Component({
    selector: 'app-sm-image-upload',
    templateUrl: './sm-image-upload.component.html',
    styleUrl: './sm-image-upload.component.scss',
    standalone: false
})
export class SmImageUploadComponent {

    app = inject(MainAppService);
    fileUpload = inject(FileUploadService);

    @Input()
    value = "";
    
    @Output()
    valueChange = new EventEmitter<string>();

    remove(): void {
        this.value = "";
        this.valueChange.emit(this.value);
    }

    async upload(): Promise<void> {
        let uploaded = Arrays.getSafe(await this.fileUpload.chooseFile(true, ["png"]), 0);
        this.value = uploaded != null ? Strings.bytesToBase64(uploaded.contents) : "";
        this.valueChange.emit(this.value);
    }
}
